// extracted by mini-css-extract-plugin
export var icon = "_ra-0";